export enum Navigation {
  Home = 'Navigasjon.Hjem',
  Search = 'Navigasjon.Søk',
  Planner = 'Navigasjon.Planlegger',
  Settings = 'Navigasjon.Innstillinger',
  Burger = 'Navigasjon.Burger',
  Favorites = 'Navigasjon.Favoritter',
  Shared = 'Navigasjon.Delt',
}

export enum Presentation {
  Next = 'Presentasjon.NesteSide',
  Previous = 'Presentasjon.ForrigeSide',
  Overview = 'Presentasjon.Innholdsoversikt',
  Exit = 'Presentasjon.Lukk',
  Fullscreen = 'Presentasjon.Fullskjerm',
}

export enum TeacherContent {
  Subject = 'Lærerinnhold.Fagside',
  Header = 'Lærerinnhold.Temaside',
  Back = 'Lærerinnhold.Tilbake',
}

export enum Colophon {
  Subject = 'Kolofon.Fagside',
  Back = 'Kolofon.Tilbake',
}

export enum Card {
  CopyUrl = 'Kort.KopierUrl',
}

export enum Settings {
  Logout = 'Innstillinger.LoggUt',
  ChangeGradeType = 'Innstillinger.EndreSkoleslag',
  ChangeLanguage = 'Innstillinger.EndreSpråk',
  Groups = 'Innstillinger.Grupper',
  Subscriptions = 'Innstillinger.Abonnement',
  ShortcutUnibok = 'Innstillinger.SnarveiUnibok',
  ShortcutBlog = 'Innstillinger.SnarveiBlogg',
  ShortcutLokus = 'Innstillinger.SnarveiLokus',
}

export enum Favorites {
  OpenList = 'Favoritter.ÅpneListe',
  CreateList = 'Favoritter.LagNyListe',
  ListBack = 'Favoritter.TilbakeFraListe',
  DeleteList = 'Favoritter.SlettListe',
  ChangeName = 'Favoritter.EndreNavn',
  Add = 'Favoritter.LeggTil',
  Remove = 'Favoritter.Fjern',
  Open = 'Favoritter.Åpne',
  SortList = 'Favoritter.Sortering',
  NavigateList = 'Favoritter.Naviger',
  DuplicateList = 'Favoritter.Dupliser',
  UploadFile = 'Favoritter.LastOppFil',
  SaveFile = 'Favoritter.LagreFil',
  CancelFile = 'Favoritter.AvbrytFil',
  AddUrl = 'Favoritter.LeggTilUrl',
  SaveUrl = 'Favoritter.LagreUrl',
  CancelUrl = 'Favoritter.AvbrytUrl',
  DownloadFile = 'Favoritter.LastNedFil',
  VisitUrl = 'Favoritter.BesøkUrl',
  EditItemName = 'Favoritter.EndreEnhetNavn',
  SaveItemName = 'Favoritter.LagreEnhetNavn',
  CancelItemName = 'Favoritter.AvbrytEnhetNavn',
}

export enum TermExam {
  CreateTask = 'Terminprøve.OpprettPrøve',
  SelectStudent = 'Terminprøve.VelgElev',
  SaveTask = 'Terminprøve.LagrePrøve',
  StartTask = 'Terminprøve.StartPrøve',
  DeleteTask = 'Terminprøve.SlettPrøve',
  CloseStudent = 'Terminprøve.StengElev',
  OpenStudent = 'Terminprøve.ÅpneElev',
  CloseTask = 'Terminprøve.StengPrøve',
  GoToTask = 'Terminprøve.GåTilPrøve',
  NavigateTask = 'Terminprøve.NavigerPrøve',
}

export enum Report {
  ToggleAccordion = 'Rapport.ToggleElev',
  FilterGroup = 'Rapport.FiltrerGruppe',
  FilterGrade = 'Rapport.FiltrerTrinn',
  FilterSubject = 'Rapport.FiltrerFag',
  FilterWeek = 'Rapport.FiltrerUke',
  FilterContext = 'Rapport.FiltrerKontekst',
}

export enum Feedback {
  Button = 'Tilbakemelding.Knapp',
  HideButton = 'Tilbakemelding.SkjulKnapp',
}

export enum Scene {
  Clone = 'Scene.Klon',
  Reset = 'Scene.Nullstill',
  Help = 'Scene.Help',
  ClickDelete = 'Scene.KlikkSlett',
  ClickCreate = 'Scene.KlikkOpprett',
}

export enum Share {
  Simple = 'Deling.Enkel',
  Edit = 'Deling.Rediger',
  Open = 'Deling.Åpne',
  PreviousWeek = 'Deling.ForrigeUke',
  NextWeek = 'Deling.NesteUke',
  CopyUrl = 'Deling.KopierUrl',
}

export enum FormWriter {
  DeliverStudent = 'Skriveramme.LeverElev',
  DownloadWord = 'Skriveramme.LastNedWord',
  DownloadPdf = 'Skriveramme.LastNedPdf',
  Print = 'Skriveramme.Print',
  ShowModelText = 'Skriveramme.VisModellTekst',
  ShowLabel = 'Skriveramme.VisEllerSkjulEtikett',
  ShowDescription = 'Skriveramme.VisEllerSkjulForklaring',
  ShowPlaceholder = 'Skriveramme.VisEllerSkjulPlassholder',
  UploadImage = 'Skriveramme.LastOppBilde',
  SelectGroup = 'Skriveramme.VelgGruppeLærer',
  SelectStudent = 'Skriveramme.VelgElevLærer',
}

export enum TextToSpeech {
  PlayButton = 'Talesyntese.SpillLyd',
  PauseButton = 'Talesyntese.PauseLyd',
  ClosePlayer = 'Talesyntese.LukkLyd',
  InfoButton = 'Talesyntese.VisInfo',
}

export enum AudioRecorder {
  StartButton = 'Lydopptak.StartOpptak',
  StopButton = 'LydOpptak.StoppOpptak,',
  PauseButton = 'LydOpptak.PauseOpptak',
  ResumeButton = 'LydOpptak.GjenopptaOpptak',
  PlayButton = 'Lydopptak.HørPåOpptak',
  StopPlay = 'LydOpptak.StoppAvspilling',
  RemoveButton = 'Lydopptak.FjernOpptak',
  DownloadButton = 'Lydopptak.LastNedOpptak',
}

export enum FileUploader {
  UpdateName = 'FilOpplasting.EndreNavn',
  UploadInput = 'FilOpplasting.LastOppFil',
  DownloadButton = 'FilOpplasting.LastNedFil',
  RemoveButton = 'FilOpplasting.SlettFil',
}

export enum Search {
  SubjectSearch = 'Fagside.Søk',
}

export enum ActivityReports {
  GroupFilter = 'Rapport.VelgGruppe',
  SubjectFilter = 'Rapport.VelgFag',
  PeriodFilter = 'Rapport.VelgPeriode',
  Activity = 'Rapport.Aktivitet',
  PaginateNext = 'Rapport.NesteSide',
  PaginateNumber = 'Rapport.SideNummer',
  PaginatePrevious = 'Rapport.ForrigeSide',
  VisitTab = 'Rapport.BesøkFane',
  AssignmentTab = 'Rapport.InnleveringFane',
  TaskTab = 'Rapport.OppgaveFane',
  BackToFrontpage = 'Rapport.TilbakeTilForside',
  BackToActivity = 'Rapport.TilbakeTilAktivitet',
  TableMode = 'Rapport.TabellModus',
  ListMode = 'Rapport.ListeModus',
  AssignmentRow = 'Rapport.InnleveringRad',
  TaskRow = 'Rapport.OppgaveRad',
  ActivitySort = 'Rapport.AktivitetSorter',
}
